@if (model$ | async; as model) {
    <app-toolbar [actions]="toolbarActions"></app-toolbar>
}
<section>
  @if (model$ | async; as model) {
    <label for="model-title"> Titre du modèle de base de données</label>
    <input id="model-title" type="text" [(ngModel)]="newTitle" (ngModelDebounceChange)="updateTitle()" />

    <app-card-list [tableList]="model.getTableList()"></app-card-list>
    <hr />
    <div>
      <label for="isEnglish">Show sentence in English</label>
      <input type="checkbox" id="isEnglish" (change)="toggleLang()" [checked]="isEnglish" />
    </div>
    <app-card-list [linkList]="model.getLinkList()" [isEnglish]="isEnglish"></app-card-list>
    <dbm-tool></dbm-tool>
  } @else {
    <p>Il n'y a aucune information</p>
  }
</section>
